import AIPromptTemplates from "./AIPromptTemplates";

export default AIPromptTemplates;
